/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/controllercontainer/controllercontainer_styles';



/* ========== ~~~~~~~~~~ EMBED CONTROLLER CONTAINER ~~~~~~~~~~ ========== */
const ControllerContainer = (props) => {
    return(
        <div className={`controllercontainer ${props.classes.controllercontainer} name-${props.name}`}>
            {props.children}
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ControllerContainer);
